<template>
  <div class="about" style="padding:15px">
    <q-card bordered class="my-card">
      <q-card-section class="bg-purple-6 text-white">
        <div class="row">
          <div class="col-12 col-md-9">
            <div class="row" style="margin: 0 5px 2px">
            <div class="text-h6">Data Pengguna</div>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="row" style="margin: 0 5px 2px">
              <q-input color="light-blue-7" v-model="cari_value" @keyup="cari_data()" outlined square :dense="true" class="bg-white" style="width:85%"/>
              <q-btn glossy class="bg-light-blue-7" @click="mdl_add = true" dense flat icon="add" style="width:15%">
                <q-tooltip class="bg-light-blue-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                  Tambah Data
                </q-tooltip>
              </q-btn>
            </div>
          </div>
        </div>
      </q-card-section>

      <q-separator dark inset />

      <q-card-section>
        <div class="tbl_responsive">
          <!-- =================================================== KONTENT =========================================================== -->
            <table width="100%">
              <tr class="h_table_head bg-purple-2">
                <th width="2.5%" class="text-center">No</th>
                <th width="15%">Nama</th>
                <th width="20%">Username</th>
                <th width="10%">Email</th>
                <!-- <th width="15%">Alamat</th> -->
                <th width="7.5%" class="text-center">#</th>
              </tr>
              <tr class="h_table_body" v-for="(data, index ) in list_data" :key="data.id">
                <td class="text-center">{{index+1}}</td>
                <td>{{data.nama}}</td>
                <td>{{data.username}}</td>
                <td>{{data.email}}</td>
                <td class="text-center">
                  <q-btn-group>
                    <q-btn @click="mdl_password = true, selectData(data)" glossy color="cyan-7" icon="lock" class="tbl_btn">
                      <q-tooltip class="bg-cyan-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                        Edit Password
                      </q-tooltip>
                    </q-btn>
                    <q-btn @click="mdl_edit = true, selectData(data)" glossy color="amber-7" icon="create" class="tbl_btn">
                      <q-tooltip class="bg-amber-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                        Edit Data
                      </q-tooltip>
                    </q-btn>
                    <q-btn @click="mdl_hapus = true, selectData(data)" glossy color="deep-orange-7" icon="delete_forever" class="tbl_btn">
                      <q-tooltip class="bg-deep-orange-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                        Hapus Data
                      </q-tooltip>
                    </q-btn>
                  </q-btn-group>
                </td>
              </tr>
            </table>

          <!-- =================================================== KONTENT =========================================================== -->
        </div>
        <hr class="hrpagin">
        <br>
        <div class="text-center">
          <q-btn @click="btn_prev" glossy color="purple-6" icon="skip_previous" class="paginate_btn" />
            <span class="h_pagination">&nbsp; {{page_first}} - {{page_last}} &nbsp;</span>
          <q-btn @click="btn_next" glossy color="purple-6" icon="skip_next" class="paginate_btn" />
        </div>
        <br>
      </q-card-section>
    </q-card>

          <!-- =================================================== MODAL =========================================================== -->

            <!-- ================================================= MODAL TAMBAH ================================================ -->
              <q-dialog v-model="mdl_add" persistent>
                <q-card class="mdl-md">
                  <q-card-section class="bg-light-blue-7">
                    <div class="text-h6 h_modalhead">Tambah Data</div>
                    <div class="text-center" v-if="pesanError">
                      <q-badge color="red-7" class="q-mb-sm"><strong>Warning! &nbsp;</strong> {{ pesanError }}</q-badge>
                      </div>
                  </q-card-section>

                  <form @submit.prevent="addData()">
                    <q-card-section class="q-pt-none">
                        <br>
                        <span class="h_lable">Nama Lengkap</span>
                        <q-input v-model="form.nama" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" />

                        <span class="h_lable">Email</span>
                        <q-input v-model="form.email" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" /> 

                        <span class="h_lable">Nomor HP</span>
                        <q-input v-model="form.hp" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" /> 

                        <span class="h_lable">Username</span>
                        <q-input v-model="form.username" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" />

                        <span class="h_lable">Password</span>
                        <q-input v-model="form.password" color="light-blue-7" type="password" outlined :dense="true" class="bg-white margin_input" />

                        <span class="h_lable">Konfirmasi Password</span>
                        <q-input v-model="form.konfirmasiPassword" color="light-blue-7" type="password" outlined :dense="true" class="bg-white margin_input" />

                        <span class="h_lable">Kelompok Pengguna</span>
                        <q-select outlined v-model="form.menu_klp" color="light-blue-7" :options="list_level" option-label="uraian" option-value="id" :dense="true" />

                    </q-card-section>

                    <q-card-actions class="bg-grey-2 mdl-footer" align="right">
                        <q-btn :loading="btn_add" color="light-blue-7" type="submit" label="Simpan" />
                        <q-btn label="Kembali" color="grey-7" v-close-popup />
                    </q-card-actions>
                  </form>

                </q-card>
              </q-dialog>
            <!-- ================================================= MODAL TAMBAH ================================================ -->

            <!-- ================================================= MODAL LIHAT ================================================ -->
            <q-dialog v-model="mdl_password" persistent>
                <q-card class="mdl-md">
                  <q-card-section class="bg-cyan-7">
                    <div class="text-h6 h_modalhead">Edit Password</div>
                    <div class="text-center" v-if="pesanError">
                      <q-badge color="red-7" class="q-mb-sm"><strong>Warning! &nbsp;</strong> {{ pesanError }}</q-badge>
                    </div>
                  </q-card-section>
                  <q-card-section class="q-pt-none">
                    <br>
                    <span class="h_lable">Password</span>
                        <q-input v-model="form.password" color="cyan-7" type="password" outlined :dense="true" class="bg-white margin_input" />

                        <span class="h_lable">Konfirmasi Password</span>
                        <q-input v-model="form.konfirmasiPassword" color="cyan-7" type="password" outlined :dense="true" class="bg-white margin_input" />
                  </q-card-section>
                  <q-card-actions class="bg-grey-2 mdl-footer" align="right">
                        <q-btn :loading="btn_add" color="cyan-7" @click="editPass()" label="Simpan" />
                        <q-btn label="Kembali" color="grey-7" v-close-popup />
                    </q-card-actions>
                </q-card>
              </q-dialog>
            <!-- ================================================= MODAL LIHAT ================================================ -->

            <!-- ================================================= MODAL EDIT ================================================ -->
            <q-dialog v-model="mdl_edit" persistent>
                <q-card class="mdl-md">
                  <q-card-section class="bg-amber-7">
                    <div class="text-h6 h_modalhead">Edit Data</div>
                    <div class="text-center" v-if="pesanError">
                      <q-badge color="red-7" class="q-mb-sm"><strong>Warning! &nbsp;</strong> {{ pesanError }}</q-badge>
                    </div>
                  </q-card-section>

                  <form @submit.prevent="editData()">

                  <q-card-section class="q-pt-none">
                    <br>

                        <span class="h_lable">Nama Lengkap</span>
                        <q-input v-model="form.nama" color="amber-7" outlined :dense="true" class="bg-white margin_input" />

                        <span class="h_lable">Email</span>
                        <q-input v-model="form.email" color="amber-7" outlined :dense="true" class="bg-white margin_input" /> 

                        <span class="h_lable">Nomor HP</span>
                        <q-input v-model="form.hp" color="amber-7" outlined :dense="true" class="bg-white margin_input" /> 

                        <span class="h_lable">Username</span>
                        <q-input v-model="form.username" color="amber-7" outlined :dense="true" class="bg-white margin_input" />

                        <span class="h_lable">Kelompok Pengguna</span>
                        <q-select outlined v-model="form.menu_klp" color="amber-7" :options="list_level" option-label="uraian" option-value="id" :dense="true" />

                  </q-card-section>

                  <q-card-actions class="bg-grey-2 mdl-footer" align="right">
                    
                      <q-btn :loading="btn_add" color="amber-7" type="submit" label="Simpan"  />
                      <q-btn label="Kembali" color="grey-7" v-close-popup />
             
                  </q-card-actions>
                  </form>
                </q-card>
              </q-dialog>
            <!-- ================================================= MODAL EDIT ================================================ -->

            <!-- ================================================ MODAL HAPUS ================================================ -->
            <q-dialog v-model="mdl_hapus" persistent>
                    <q-card class="mdl-sm ">
                      <q-card-section class="q-pt-none text-center bg-deep-orange-3">
                          <form @submit.prevent="removeData(form.id)">
                              <br>
                              <img src="img/alert.png" alt="" width="75"> <br>
                              <span class="h_notifikasi">APAKAH ANDA YAKIN INGIN MENGHAPUS DATA INI??</span>
                              <input type="submit" style="position: absolute; left: -9999px"/>
                              <br>
                              <br>
                            <q-btn label="Kembali" size="sm" color="grey-7"  v-close-popup/>
                            &nbsp;
                            <q-btn type="submit" label="Hapus" size="sm" color="deep-orange-7" v-close-popup/>

                          </form>
                      </q-card-section>
                    </q-card>
                  </q-dialog>

            <!-- ================================================ MODAL HAPUS ================================================ -->

          <!-- =================================================== MODAL =========================================================== -->

  </div>
</template>

<style>
</style>

<script>
import Joi from "joi";

const schema = Joi.object().keys({
    username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(6).max(13).required(),
    password: Joi.string().min(6).required(),
    });

    const checkUser = Joi.object().keys({
    username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(6).max(13).required()
    });

export default {
  name: 'PenggunaPage',
  data() {
    return {
      form : {
        id : '',
        nama : '',
        hp : '',
        email : '',
        username : '',
        password : '',
        konfirmasiPassword : '',
        menu_klp : '',
      },
      pesanError: '',

      list_data : [],
      list_level : [],

      // kelompok : [{id: '17', judul: 'Administrator'}, {id: '18', judul: 'Admin'}],

      page_first: 1,
      page_last: 0,
      page_limit: 10,
      cari_value: "",

      mdl_add: false,
      mdl_password: false,
      mdl_edit: false,
      mdl_hapus: false,
    }
  },

  watch: {
    user: {
        handler() {
            this.pesanError = "";
        },
        deep: true
    }
  },

  methods: {
    getView : function(){
      this.$store.commit("showLoading");
      fetch(this.$store.state.url.URL_PENGGUNA + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jmlData;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },

    addData: function() {
      this.pesanError = "";
        if (this.validUser()) {
            // Jika user sdh valid lakukan pengiriman data ke server
            // const body = {
            //   username: this.form.username,
            //   password: this.form.password
            // };
            // this.signingUp = true;

            fetch(this.$store.state.url.URL_PENGGUNA + "signup", {
                method: "POST",
                body: JSON.stringify(this.form),
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }
            }).then((response) => {
                // this.signingUp = false;
                if (response.ok) {
                    this.Notify('Sukses Menambah Data', 'light-blue-7', 'check_circle_outline');
                    this.getView();
                    // this.$router.push('/login');
                    // return response.json();
                }
                else{
                  return response.json().then(error => {
                    throw new Error(error.message);
                  });

                }
            })
            .catch((error) => {
              setTimeout(() => {
                // this.signingUp = false;
                this.pesanError = error.message;
              }, 1000);
            });
        }else{
          console.log("Tidak Valid");

        }

    },

    validUser : function(){
      if (this.form.password !== this.form.konfirmasiPassword) {
        this.pesanError = " Password dan Konfirmasi Password harus sama.! ";
          // this.Pesan('Password dan Confirm Password harus sama.!', 'accent', 'clear');
          return false;
      }
      // Memulai proses validasi melalui skema Joi yang sebelumnya dibuat
      // req.body merupakan data yang di kirim oleh client dan schema merupakan skema joi yg di buat sebelumnya
      const body = {
              username: this.form.username,
              password: this.form.password
      };

      const result = schema.validate(body);

      console.log(result.error)

      if (result.error == null || result.error ==undefined) {
          return true;
      }

      if (result.error.message.includes("username")) {
          // jika pesan error yang dihasilkan mengandung char "username" maka
          this.pesanError = "Username tidak valid (Min : 6 dan Max : 14 Karakter)";
        // this.Notify('Username tidak valid (Min : 6 dan Max : 14 Karakter)', 'accent', 'clear');
      } else {
          // this.Notify('Password tidak valid (Min : 6 Karakter)', 'accent', 'clear');
          this.pesanError = "Password tidak valid (Min : 6 Karakter)";
        //   console.log(result.error);
      }
      return false;
    },

    validasiUser : function(){
      const body = {
              username: this.form.username
      };

      const result = checkUser.validate(body);

      console.log(result.error)

      if (result.error == null || result.error ==undefined) {
          return true;
      }

      if (result.error.message.includes("username")) {
          // jika pesan error yang dihasilkan mengandung char "username" maka
          this.pesanError = "Username tidak valid (Min : 6 dan Max : 14 Karakter)";
        // this.Notify('Username tidak valid (Min : 6 dan Max : 14 Karakter)', 'accent', 'clear');
      }
      return false;
    },

    editData : function(){
      this.pesanError = "";
        if (this.validasiUser()) {
      fetch(this.$store.state.url.URL_PENGGUNA + "editData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then((response) => {
                // this.signingUp = false;
                if (response.ok) {
                    this.Notify('Sukses Mengedit Data', 'amber-7', 'check_circle_outline');
                    this.getView();
                    // this.$router.push('/login');
                    // return response.json();
                }
                else{
                  return response.json().then(error => {
                    throw new Error(error.message);
                  });

                }
            })
            .catch((error) => {
              setTimeout(() => {
                // this.signingUp = false;
                this.pesanError = error.message;
              }, 1000);
            });
      //       .then(resp => {
      //     this.Notify('Sukses Mengedit Data', 'amber-7', 'check_circle_outline');
      //     this.getView();
      // });
    } else{
      console.log("Tidak Valid");
    }
    },

    editPass: function() {
      if (this.form.password !== this.form.konfirmasiPassword) {
        this.pesanError = " Password dan Konfirmasi Password harus sama.! ";
          // this.alertku('warning', 'Password dan Confirm Password Harus Sama!.');
//          return false;
      }
      else{
        this.pesanError = '';
        fetch(this.$store.state.url.URL_PENGGUNA + "editDataPass", {
            method: "POST",
            headers: {
                'content-type' : 'application/json',
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id : this.form.id,
                password : this.form.password,
            })
        }).then(res_data => {
            this.Notify('Sukses Mengedit Password', 'cyan-7', 'check_circle_outline');
            this.getView();
        });

      }

    },

    removeData : function(a){
      // console.log(a);
      // console.log(b);
      fetch(this.$store.state.url.URL_PENGGUNA + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : a})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'deep-orange-7', 'check_circle_outline');
          this.getView();
      });

    },
    selectData : function(data){
        this.form.id = data.id
        this.form.nama = data.nama
        this.form.username = data.username
        // this.form.password = data.password
        // this.form.konfirmasiPassword = data.konfirmasiPassword
        this.form.email = data.email
        this.form.hp = data.hp
        this.form.menu_klp = data.menu_klp
    },
    getLevel: function() {
      fetch(this.$store.state.url.URL_LEVEL + "list", {
            method: "GET",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            }
        })
        .then(res => res.json())
        .then(res_data => {
        this.list_level = res_data;
        console.log(res_data)
        console.log(this.list_level);
        });
    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, color, icon){
          this.$q.notify({
            message: message,
            color: color,
            icon: icon,
            position : 'center',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

    // ====================================== PAGINATE ====================================

  },
  mounted() {
    this.getView();
    this.getLevel();
  }
}
</script>
